<template>
<v-container>
 <h1>Attiva il tuo account </h1>
 <p>Inserisci il codice ricevuto via email all'indirizzo <i>"{{userData.Email}}"</i> </p>
    <v-col cols="6">
        <v-text-field
          ref="input"
          label="Codice di Conferma"
          name="codiceConferma"
          type="text"
          filled
           v-model="userData.ActivationCode"
        ></v-text-field>
      </v-col>
</v-container>
</template>
<script>


export default {
 
   props:["userData"],
  data:() => ({
    error: null,
  }),
 
  
};
</script>